
import { call, put, takeEvery } from 'redux-saga/effects'
import {
    createSegment as createSegmentApi, getCustomerCountApi
} from '../../network/requests'
import {
    createNewSegmentSuccess,
    createNewSegmentError,
    setTargetCustomerCount,
    getCustomerCountError
} from './createSegmentsReducer'
import { showSummaryAction } from "../../components/SegmentSummary/segmentSummaryReducer"
import { showLoader, hideLoader } from "../../components/Loader/loaderReducer"
import { showNudge, SEVEARITY_CONTS } from "../../components/Nudge/nudgeReducer";

function* createSegment(action) {
    yield put(showLoader())
    let successMessage = "Segment Creation in progress"
    try {
        const data = yield call(createSegmentApi, action.payload)
        yield put(createNewSegmentSuccess({ ...data, ...action.payload }))
        yield put(showNudge({
            message: successMessage,
            type: SEVEARITY_CONTS.success
        }))
        yield put(showSummaryAction({ ...data, ...action.payload }))
    } catch (e) {
        yield put(createNewSegmentError(e?.error))
        yield put(showNudge({
            message: e?.error?.error || "Something went wrong",
            type: SEVEARITY_CONTS.error
        }))
    } finally {
        yield put(hideLoader())
    }
}

function* getCustomerCount(action) {
    try {
        const data = yield call(getCustomerCountApi, action.payload);
        yield put(setTargetCustomerCount(data?.count));
    } catch (e) {
        yield put(getCustomerCountError(e?.error?.error));
    }
}

function* createSegmentsSaga() {
    yield takeEvery('CreateSegment/createNewSegment', createSegment);
    yield takeEvery('CreateSegment/getCustomerCount', getCustomerCount);
}

export default createSegmentsSaga